export enum SkeletonConfig {
  PROFILE = 'profile',
  GENERAL = 'general',
}
